import { mapActions, mapGetters, mapMutations } from 'vuex'
import moment from 'moment'

export default {
  props: {
    value: {
      required: true,
      type: Object,
      default: false
    },
    period: {
      required: true,
      type: Object,
      default: false
    }
  },
  data () {
    return {
      isLoading: false,
      dialog: false,
      headers: [
        { text: 'Nome da Cesta', value: 'basketName', align: 'left' },
        { text: 'Quantidade de Consultas', value: 'numberOfCalls', align: 'right' },
        { text: 'Valor Cesta (R$)', value: 'valueOfBasket', align: 'right' },
        { text: 'Valor Cobrado (R$)', value: 'valueCalls', align: 'right' }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'getterClientsExtractCommershalById'
    ]),
    options () {
      return {
        loading: this.isLoading
      }
    }
  },
  mounted () {
    this.dialog = true

    this.loadInformationClient()
  },
  methods: {
    ...mapActions([
      'actionListExtractByClient'
    ]),
    ...mapMutations([
      'CLIENTSBYID'
    ]),
    formatDate (date) {
      return moment(date).format('DD/MM/YYYY HH:mm:ss')
    },
    loadInformationClient () {
      if (this.value && this.value.clientId) {
        const params = {
          idClient: this.value.clientId || null,
          startDate: `${moment(this.period.startDate).format('YYYY-MM-DD')}T00:00:00`,
          endDate: `${moment(this.period.endDate).format('YYYY-MM-DD')}T23:59:59`
        }

        this.isLoading = true

        this.actionListExtractByClient(params)
          .then(() => {
            this.isLoading = false
          })
          .catch(() => {
            this.isLoading = false
          })
      } else {
        this.sendToast({
          text: 'Estão faltando algumas informações para exibir os dados!',
          type: 'warning'
        })
      }
    },
    closeModal () {
      this.isLoading = this.dialog = false

      setTimeout(() => {
        this.$emit('input', null)

        this.CLIENTSBYID()
      }, 300)
    }
  }
}
